import React, { useState } from "react";

import { valueStrings, WidgetStrings } from "constants/constantStrings";

import DupontDialog from "components/DupontDialog";
import InputBox from "components/InputBox";

import "./index.scss";

export default function CriticalDeleteDialog(props) {
  const { title, description, onDialogClose, isOverlayLoader, hideReason } = props;
  const [deleteReason, setDeleteReason] = useState("");
  const confirmBtnText = props.confirmBtnText || valueStrings.yesDelete;
  const reasonChangeHandler = reason => setDeleteReason(reason);

  const closeHandler = async action => {
    const data = { action };
    if (action === "CONFIRM") {
      data.deleteReason = deleteReason;
    }
    onDialogClose(data);
  };
  
  const titleClassName = "critical-delete-title";

  return (
    <DupontDialog
      open={true}
      type="warning"
      title={title}
      titleClassName={titleClassName}
      cancelBtnText={valueStrings.cancel}
      confirmBtnText={confirmBtnText}
      onClose={closeHandler}
      customClass="critical-dialog--width"
      isOverlayLoader={isOverlayLoader}
    >
      <div className="critical-delete-dailog-main">
        {description}
        {!hideReason && (
          <div className="delete-item-reason">
            <label className="dupont-form-label" htmlFor="system-delete-reason">
              {valueStrings.reason} <span className="delete-reason-optional">({valueStrings.optional})</span>
            </label>
            <InputBox name="system-delete-reason" value={deleteReason} placeholder={WidgetStrings.typeHere} onChange={reasonChangeHandler} rows="5" />
          </div>
        )}
      </div>
    </DupontDialog>
  );
}
